<template>
    <div :style=" me ? alignRight : alignLeft " class="chat-message--wrapper">
        <div
                :style=" me ? (wait ? colorWait : colorRight) : colorLeft "
                v-if="message.startsWith('http') || message.startsWith('https')"
                class="chat-message--content"
        >
            <a      :style=" me ? linkRight : linkLeft "
                    target="_blank"
                    :href="message"
                    v-html="message">
            </a>
            <spinner
                    v-if="wait"
                    size="28px"
                    :show="true"
                    color="gray"
                    class="chat-message__loader">
            </spinner>
        </div>

        <div
                :style=" [me ? (wait ? colorWait : colorRight) : colorLeft,
                me ? borderLeft : borderRight,
                first ? (me ? borderRightFirst : borderLeftFirst) : '',
                end ? (me ? borderRightEnd : borderLeftEnd) : '' ]"
                v-else
                class="chat-message--content" >
            {{ message }}
            <spinner
                    v-if="wait"
                    size="28px"
                    :show="true"
                    color="gray"
                    class="chat-message__loader">
            </spinner>
        </div>

        <div class="chat_read_message" v-if="isShowRead"
        >
            {{ $t('read') }}
        </div>
    </div>
</template>

<script>
import Spinner from './Spinner'

export default {
  name: 'Message',
  components: { Spinner },
  props: {
    message: String,
    me: Boolean,
    wait: Boolean,
    first: {
      type:Boolean,
      default: false
    },
    end: {
      type:Boolean,
      default: false
    },
    isShowRead: {
      type: Boolean,
      default: false
    }
  },
  computed: {

  },
  data () {
    return {
      alignLeft: {
        'align-self': 'flex-start'
      },
      alignRight: {
        'align-self': 'flex-end'
      },
      linkLeft: {
        'color': '#000000'
      },
      linkRight: {
        'color': '#ffffff'
      },
      colorRight: {
          'background-color': '#db4437',
          'color': '#ffffff'
      },
      colorLeft: {
          'background-color': '#ffffff',
          'color': '#000000'
      },
      colorWait: {
          'background-color': 'gray',
          'color': '#ffffff'
      },
      borderLeftFirst : {
          'border-top-left-radius': '12px',
      },
      borderRightFirst: {
          'border-top-right-radius': '12px',
      },
      borderRightEnd: {
          'border-bottom-right-radius': '12px'
      },
      borderLeftEnd: {
          'border-bottom-left-radius': '12px'
      },
      borderRight: {
          'border-top-right-radius': '12px',
          'border-bottom-right-radius': '12px'
      },
      borderLeft: {
          'border-top-left-radius': '12px',
          'border-bottom-left-radius': '12px'
      }
    }
  }
}
</script>

<style lang="scss">
.chat-message--wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 3px;
    position: relative;
    .chat-message--content {
        min-height: 32px;
        padding: 2px 12px;
        text-align: left;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        word-break: break-word;
        white-space: pre-line;
        border-radius: 4px;
        .chat-message__loader {
            position: absolute;
            left: -24px;
        }
    }
    .chat_read_message {
        font-size: 13px;
        text-align: right;
        margin-right: 8px;
    }
}
</style>
